var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    "aria-hidden": "true",
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebookclip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36L0.880983 23.5623L7.41987 3.4377L28.5801 3.4377L35.119 23.5623L18 36Z",
    fill: "#FFE575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3404 27V18.8033H22.0211L22.404 15.6051H19.3404V13.6063C19.3404 12.7066 19.6273 12.0072 20.8722 12.0072H22.5V9.10481C22.117 9.10481 21.1592 9.00848 20.1063 9.00848C19.5733 8.97153 19.039 9.05562 18.5402 9.25495C18.0413 9.45429 17.5898 9.76412 17.2167 10.1631C16.8436 10.5621 16.5578 11.0408 16.3789 11.5662C16.2001 12.0916 16.1325 12.6512 16.1807 13.2065V15.6051H13.5V18.8033H16.1807V26.999L19.3404 27Z",
    fill: "#183029"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.933dba9a.svg";
export { ForwardRef as ReactComponent };